<template>
  <table class="w-full border-blue-lighter border-collapse border">
    <thead class="bg-blue-lightest">
      <tr>
        <th class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">{{ $t('type') }}</th>
        <th class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">{{ $t('total') }}</th>
        <th class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">{{ $t('executed2') }}</th>
        <th v-if="companyAlias !== 'x-elio'" class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">{{ $t('issues') }}</th>
        <th v-if="companyAlias === 'solaring'" class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">{{ $t('pv_dashboard_execution_percent') }}</th>
        <th v-else class="p-2 text-sm font-semibold text-blue-dark border border-blue-lighter">%</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="lyr in layers" :key="lyr.code">
        <td class="justify-start w-auto h-full p-2 align-middle border border-blue-lighter">
          {{ $t(lyr.code) }}
          <slot name="layer-action" :layer="lyr"></slot>
        </td>
        <td class="justify-start w-auto h-full p-2 align-middle border border-blue-lighter">{{ getTotal(lyr) }}</td>
        <td class="justify-start w-auto h-full p-2 align-middle border border-blue-lighter">{{ getExecuted(lyr) }}</td>
        <td v-if="companyAlias !== 'x-elio'"
          class="justify-start w-auto h-full p-2 align-middle border border-blue-lighter"
        >
          {{ getIncidents(lyr) }}
        </td>
        <td class="justify-start w-auto h-full p-2 align-middle border border-blue-lighter">
          <span v-if="useExecutedRatio">
            {{ getExecuted(lyr) > 0 ? truncateToFixed((getExecuted(lyr) / getTotal(lyr)) * 100, 2) : 0 }}
          </span>
          <span v-else>
            {{ truncateToFixed(getProgress(lyr), 2) }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "SummaryTable",

  props: {
    layers: { type: Array, required: true },
    companyAlias: { type: String, required: true },
    getTotal: { type: Function, required: true },
    getExecuted: { type: Function, required: true },
    getIncidents: { type: Function, required: true },
    getProgress: { type: Function, required: true },
    useExecutedRatio: { type: Boolean, default: false },
  },

  methods: {
    truncateToFixed(num, decimals) {
      const factor = Math.pow(10, decimals);
      return Math.floor(num * factor) / factor;
    },
  },
};
</script>
